export const GET_SETTINGS_REQUEST = 'GET_SETTINGS_REQUEST';
export const GET_SETTINGS_SUCCESS = 'GET_SETTINGS_SUCCESS';
export const GET_SETTINGS_FAILED = 'GET_SETTINGS_FAILED';

export const SET_SETTINGS_REQUEST = 'SET_SETTINGS_REQUEST';
export const SET_SETTINGS_SUCCESS = 'SET_SETTINGS_SUCCESS';
export const SET_SETTINGS_FAILED = 'SET_SETTINGS_FAILED';

export const GET_SETTINGS_USERS_REQUEST = 'GET_SETTINGS_USERS_REQUEST';
export const GET_SETTINGS_USERS_SUCCESS = 'GET_SETTINGS_USERS_SUCCESS';
export const GET_SETTINGS_USERS_FAILED = 'GET_SETTINGS_USERS_FAILED';

export const GET_SIGNATURE_ALERTS_REQUEST = 'GET_SIGNATURE_ALERTS_REQUEST';
export const GET_SIGNATURE_ALERTS_SUCCESS = 'GET_SIGNATURE_ALERTS_SUCCESS';
export const GET_SIGNATURE_ALERTS_FAILED = 'GET_SIGNATURE_ALERTS_FAILED';

export const UPDATE_SIGNATURE_ALERT_REQUEST = 'UPDATE_SIGNATURE_ALERT_REQUEST';
export const UPDATE_SIGNATURE_ALERT_SUCCESS = 'UPDATE_SIGNATURE_ALERT_SUCCESS';
export const UPDATE_SIGNATURE_ALERT_FAILED = 'UPDATE_SIGNATURE_ALERT_FAILED';
